import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas

import Box from '@mui/material/Box';
import Schema from '../../../../../../lib/paths/antrag_FULL_Paths.json';
import { BICValidation, IBANValidation, Required } from '../../../../../../lib/validation/ValidationTypes';
const P = Schema.attributes;

const BankDaten: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Bankdaten' description={PLATZHALTER_TEXT} />
			<Box>
				<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
			</Box>
		</>
	);
};

export default BankDaten;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Kontodaten_Kontoinhaber, validation: [{ validateFunction: Required }] },
				{ ...P.Kontodaten_Institut, validation: [{ validateFunction: Required }] },
			],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Kontodaten_IBAN, validation: [{ validateFunction: Required }, { validateFunction: IBANValidation }] },
				{ ...P.Kontodaten_BIC, validation: [{ validateFunction: Required }, { validateFunction: BICValidation }] },
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBankDaten = () => {
	return concat(formStruc());
};
